import React, { useEffect } from 'react';
// import { AboutItems } from './AboutItems'
import bdots from '../../assets/color_grid.png';
import AOS from 'aos';

import './About.css';

const About = () => {

    useEffect(() => {
        AOS.init({ duration: 800 })
    }, [])

    return (
        <div className="about" id="about">
            <div className="container">
                <img src={bdots} alt="dots" className="bdots" loading="lazy" draggable="false" />
                <span className="l-about" data-aos="fade-right" data-aos-once="true">About</span>
                <div className='row'>
                    <div className="col-10 about_box">
                        <h2 data-aos="fade-up" data-aos-once="true" data-aos-delay="100">About me</h2>
                        <p data-aos="fade-up" data-aos-once="true" data-aos-delay="200">Hi, I'm Chintan — a passionate Software Engineer with a Master’s in Computer Science from the University of Illinois at Chicago and over two years of hands-on experience building scalable, high-performance web applications.<br/><br/>
                            My expertise spans across modern technologies like React, Node.js, TypeScript, Python, and Laravel. I specialize in developing full-stack applications and microservices, integrating clean UI/UX with robust backend systems. From implementing secure authentication to deploying apps on Linux servers and automating pipelines with CI/CD, I bring both precision and creativity to every project. <br/><br/>
                            Whether it's creating interactive frontends, architecting RESTful APIs, or designing real-time data pipelines with AWS and Kafka, I enjoy solving complex problems and continuously refining my craft. <br/><br/>
                            I'm always excited to collaborate on meaningful software that makes a real impact. Let’s build something great together! <br/><br/>
                        </p>
                        <a href="https://drive.google.com/file/d/1x2UopXCzYOOwZGo9eJEshYclo7vwGAWz/view?usp=sharing"
                            rel="noopener noreferrer" data-aos="fade-up" data-aos-once="true" data-aos-delay="300" target="_blank"
                        >
                            <button className="dbtn" data-aos="fade-up"
                                data-aos-once="true"
                                data-aos-delay="300">
                                Download CV
                            </button>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default About;